import React, { useState, useEffect } from 'react';
import InnerHeader from './InnerHeader';
import { BASE_URL } from './BaseUrl';
import axios from "axios";
import { Link, useParams } from 'react-router-dom';
import decryptedUserId from '../Utils/UserID';

const WorkExperience = () => {
    const { empolyeeid } = useParams();
    const [rows, setRows] = useState([]);


     useEffect(() => {
        if (empolyeeid) {
            fetchAcademicData();
        }
    }, [empolyeeid]);
    
    console.log("Fetching academic data for empolyeeid:", empolyeeid);
    
    
        const fetchAcademicData = async () => {
  try {
    const res = await axios.post(`${BASE_URL}/getempolyee_work_experience_records`, { empolyeeid });
    const data = res.data;
    console.log("Work Experience Data:", data);
const formattedRows = (data || []).map(d => {
  console.log('Mapped row ExperienceID:', d.ExperienceID);
  return {
      ExperienceID: d.ExperienceID || null,
      Company: d.Company || '',
      BusinessNature: d.BusinessNature || '',
      Designation: d.Designation || '',
      Address: d.Address || '',
      City: d.City || '',
      LastDate: d.LastDate ? formatDateToYYYYMMDD(d.LastDate) : '',
      Telephone: d.Telephone || '',
      Duration: d.Duration || '',
      GrossSalary: d.GrossSalary || '',
      NetSalary: d.NetSalary || '',
      LeaveReason: d.LeaveReason || ''
      
   
    }; });
    console.log("Formatted Rows:", formattedRows);    

    setRows(formattedRows);

  } catch (err) {
    console.error("Error fetching work experience:", err);
  }

};

    
      
    
      const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        let formattedValue = value;
        if (name === "Telephone") {
          formattedValue = String(value || "").replace(/\D/g, "").slice(0, 10);
        }
        const updatedRows = [...rows];
        updatedRows[index][name] = formattedValue;
        setRows(updatedRows);
      };
    
      const addNewRow = () => {
  setRows([
    ...rows,
    {
  ExperienceID: null,
  Company: '',
  BusinessNature: '',
  Designation: '',
  Address: '',
  City: '',
  Telephone: '',
  Duration: '',
  GrossSalary: '',
  NetSalary: '',
  LeaveReason: '',
  LastDate: ''
}

  ]);
};

    
      
    
     const handleSave = async (e) => {
  e.preventDefault();

  const formattedRecords = rows.map(record => {
    if (!record.Company || !record.BusinessNature || !record.Designation || !record.LastDate) {
      return null; // Skip incomplete records
    }

    return {
      ExperienceID: record.ExperienceID || null, // null for new entries
      Company: record.Company,
      BusinessNature: record.BusinessNature,
      Designation: record.Designation,
      Address: record.Address,
      City: record.City,
      LastDate: formatDateToYYYYMMDD(record.LastDate),
      Telephone: record.Telephone,
      Duration: record.Duration,
      GrossSalary: record.GrossSalary,
      NetSalary: record.NetSalary,
      LeaveReason: record.LeaveReason
    };
  }).filter(Boolean); // Remove null records

  if (formattedRecords.length === 0) {
    alert("Please complete at least one record with all required fields.");
    return;
  }

  const data = {
    empolyeeid: empolyeeid,
    createdBy: decryptedUserId(),
    updatedBy: decryptedUserId(),
    records: formattedRecords
  };

  try {
    const res = await axios.post(`${BASE_URL}/save_work_experience`, data);

    if (res.data.success) {
      alert("Records saved successfully!");
      fetchAcademicData(); // Refresh data if needed
    } else {
      alert("Failed to save records: " + res.data.message);
    }
  } catch (err) {
    console.error("Error saving records:", err);
    alert("An error occurred while saving.");
  }
};


// 🔧 Helper function to convert to YYYY-MM-DD
function formatDateToYYYYMMDD(dateString) {
    const date = new Date(dateString);
    if (isNaN(date)) return ""; // handle invalid date
    const year = date.getFullYear();
    const month = (`0${date.getMonth() + 1}`).slice(-2); // pad with 0
    const day = (`0${date.getDate()}`).slice(-2);
    return `${year}-${month}-${day}`;
}

    
      const handleCancelRow = (indexToRemove) => {
        const updatedRows = rows.filter((_, index) => index !== indexToRemove);
        setRows(updatedRows);
      };
      const activeEmpId = (empolyeeid && empolyeeid !== ":empolyeeid" && empolyeeid !== "undefined") ? empolyeeid : ":empolyeeid";

    return (
        <div className="container-fluid page-body-wrapper">
            <InnerHeader />
            <div className="main-panel">
                <div className="content-wrapper">
                    <div className="d-flex flex-wrap">
                        <div className='px-2 mx-2'><Link to={`/employeepersonaldetails/${activeEmpId}`}><h4>Personal Information</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/emailcredential/${activeEmpId}`}><h4>Email Credential</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/academicqualificationsemp/${activeEmpId}`}><h4>Academic Qualification</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/workexperience/${activeEmpId}`}><h4>Work Experience</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/leavestructure/${activeEmpId}`}><h4>Leave Structure</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/salarystructure/${activeEmpId}`}><h4>Salary Structure</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/weeklyoff/${activeEmpId}`}><h4>Weekly Off</h4></Link></div>
                        <div className='px-2 mx-2'><Link to={`/intimesetting/${activeEmpId}`}><h4>Intime Setting</h4></Link></div>
                    </div>

                    <div className="col-lg-12 grid-margin stretch-card mt-4">
                        <div className="card">
                            <div className="card-body">
                                <h2 className="card-title titleback">Work Experience</h2>
                                <hr />

                                {rows.map((row, index) => (
                                    <div key={index} className="border p-3 mb-4 rounded bg-light">
                                        <div className="row">
                                            <div className="col-md-2">
                                                <label>Company</label>
                                                <input type="text" className="form-control" name="Company" value={row.Company} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Business Nature</label>
                                                <input type="text" className="form-control" name="BusinessNature" value={row.BusinessNature} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Designation</label>
                                                <input type="text" className="form-control" name="Designation" value={row.Designation} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Address</label>
                                                <input type="text" className="form-control" name="Address" value={row.Address} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>City</label>
                                                <input type="text" className="form-control" name="City" value={row.City} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            
                                            <div className="col-md-2">
                                                <label>Last Date</label>
                                                <input type="date" className="form-control" name="LastDate" value={row.LastDate} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col-md-2">
                                                <label>Telephone</label>
                                                <input type="tel" maxLength={10} inputMode="numeric" className="form-control" name="Telephone" placeholder="10-digit Telephone" value={row.Telephone} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Duration</label>
                                                <input type="text" className="form-control" name="Duration" value={row.Duration} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Gross Salary</label>
                                                <input type="text" className="form-control" name="GrossSalary" value={row.GrossSalary} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Net Salary</label>
                                                <input type="text" className="form-control" name="NetSalary" value={row.NetSalary} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                            <div className="col-md-2">
                                                <label>Leave Reason</label>
                                                <input type="text" className="form-control" name="LeaveReason" value={row.LeaveReason} onChange={(e) => handleInputChange(e, index)} />
                                            </div>
                                        </div>

                                        <div className="row mt-3">
                                            <div className="col-md-3 d-flex align-items-end">
                                                <button className="btn btn-danger btn-sm" onClick={() => handleCancelRow(index)}>Remove</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}

                                <div className="mt-4">
                                    <button type="button" className="btn btn-success" onClick={addNewRow}>Add Row</button>
                                    <button type="submit" className="btn btn-primary mx-2" onClick={handleSave}>Save</button>
                                    <button type="button" className="btn btn-light" onClick={() => window.location.reload()}>Close</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkExperience;
